import i18next from 'i18next';

import {appStore} from '@/entities/app';
import {balanceStore} from '@/entities/balance';
import {boostStore} from '@/entities/boost';
import {discoveryStore} from '@/entities/discovery';
import {featuresActivityStore} from '@/entities/featuresActivity';
import {geoStore} from '@/entities/geo';
import {matchStore} from '@/entities/match';
import {messageStore} from '@/entities/message';
import {notificationStore} from '@/entities/notification';
import {peopleStore} from '@/entities/people';
import {settingsStore} from '@/entities/settings';
import {subscriptionStore} from '@/entities/subscription';
import {unreadStore} from '@/entities/unread';
import {userStore} from '@/entities/user';
import {DEBUG} from '@/shared/config';
import {
  getSignUpInfo,
  getSignUpInfoItem,
  patchSignUpInfo,
} from '@/shared/lib/localStorage/signUp/signUpInfo';
import {getLanguage, setLanguage, localize} from '@/shared/services/i18n';

if (DEBUG && typeof window !== 'undefined') {
  // Expose storages for debugging purposes
  (window as any).__debug = {
    storages: {
      discoveryStore,
      userStore,
      matchStore,
      messageStore,
      geoStore,
      notificationStore,
      boostStore,
      appStore,
      settingsStore,
      featuresActivityStore,
      balanceStore,
      subscriptionStore,
      peopleStore,
      unreadStore,
    },
    signUp: {
      patchSignUpInfo,
      getSignUpInfo,
      getSignUpInfoItem,
    },
    services: {
      i18n: {
        t: localize,
        options: i18next.options,
        getLanguage,
        setLanguage,
      },
    },
  };
}
